<template>
	<main id="form">
		<form autocomplete="off" v-on:submit.self.stop.prevent="validateForm()">
			<h2>{{this.properties && getLabel(this.properties.title)}}</h2>
			<ul v-if="properties.fields">
				<li>
					<pools_checkbox_input v-on:validateField="validateField" v-bind:params="getParams('pools_checkbox')" v-bind:oldValue="oldValue[fieldName]" v-bind:lang="lang" v-bind:templateIndex="templateIndex"></pools_checkbox_input>
				</li>
			</ul>
			<button v-bind:class="isActive ? 'selected' : ''" type="submit">{{getLabel(fields.next)}}</button>
		</form>
	</main>
</template>

<script>
//Input components
import pools_checkbox_input from '@/components/candidate_forms/pools_checkbox_input.vue';

import lib from '@/libs/main.js';
import ey_spec from '@/libs/ey_spec.js';
import componentTools from '@/libs/componentTools.js';

function checkForm(scope){
	if(!scope.properties || !scope.properties.fields || !Array.isArray(scope.properties.fields)) return true;
	return scope.properties.fields.every(field => {
		if(!field.params.compulsory) return true;
		return scope.answer[field.params.name];
	});
}
export default {
	name: 'secteurTpl',
	data() {
		return {
			availableResults : [],
			answer : {},
			oldValue : {},
			isActive : false,
			fields : {
				next : {
					fr : 'Valider',
					en : 'Next'
				}
			}
		}
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	components : {
		pools_checkbox_input
	},
	methods : {
		validateForm : function() {
			if(!checkForm(this)) return;
			var t = this;
			let out = {};
			let answer = {};
			this.properties.fields.forEach( field => {
				if(field.params.name == "secteur" && this.answer[field.params.name]){
					this.answer[field.params.name].forEach(function(k,i){
						out[t.availableResults.choices[k].value] = true;
					});
				}
			});
			delete this.currentSession.stepsResults.candidate_wishes0Tpl_4
			delete this.currentSession.stepsResults.candidate_wishes1Tpl_5
			delete this.currentSession.stepsResults.candidate_wishes2Tpl_6
			delete this.currentSession.stepsResults.candidate_wishes3Tpl_7
			delete this.currentSession.stepsResults.candidate_wishes4Tpl_8
			delete this.currentSession.stepsResults.candidate_wishesTpl_9;
			this.$emit('validateStep', this.$options.name, out);
		},
		validateField : function(name, value) {
			this.answer[name] = value;
			this.isActive = checkForm(this);
		},
		validateExtraInput : function(name, value) {
			value = this.availableResults[value].value
			this.answer[name] = value;
			this.isActive = checkForm(this);

		},
		scrollToThisInput : function(event) {
			return lib.scrollToElem(event.target);
		},
		getParams : function(type){
			const defaultChoices = JSON.parse(JSON.stringify(this.properties && this.properties.fields && this.properties.fields.find(x => x.type == type).params))
			this.availableResults = defaultChoices;
			return defaultChoices;
		},
		getLabel : componentTools.getLabel
	},
	computed : {
		fieldName : function(index) {
			const params = this.getParams('pools_checkbox');
			return params && params.name;
		},
	},
	watch : {
		templateIndex : {
			handler : function(val, oldval){
				let scope = this;
				let tplRes = scope.currentSession && scope.currentSession.stepsResults && scope.currentSession.stepsResults[scope.$options.name + '_' + scope.templateIndex];
				if(!tplRes){
					scope.oldValue = {};
					scope.answer = {};
				} else {
					scope.oldValue = JSON.parse(JSON.stringify(tplRes));
					scope.answer = JSON.parse(JSON.stringify(tplRes));
				}
			}
		},
	},
	created : function(){
		componentTools.created.call(this);
		const oldRes = this.currentSession.stepsResults[this.$options.name + '_' + this.templateIndex];
		// can't save properly due to _id choice translations
		// if(oldRes) this.oldValue = {candidate_wishes : JSON.parse(JSON.stringify(oldRes)).candidate_wishes.map(e=>e.value)};

	}
};
</script>

<style lang="less">
@import '../../assets/less/conf.import.less';
#form ul{
	li{
		position: relative;
		margin-top: 3%;
		margin-bottom: 3%;
		label{
			position: absolute;
			left: 0;
			margin-top: 2%;
			max-width: 40%;
			text-align: left;
		}
		input{
			&[type="date"]{
				width: 40%;
				margin-left: 60%;
			}
			&[type="checkbox"], &[type="radio"]{
				display: inline-block;
			}
			&[type="text"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="email"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="number"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="tel"]{
				width: 50%;
				margin-left: 50%;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ey/secteur.vue